// extracted by mini-css-extract-plugin
export default {"root":"_37EY3","priority-primary":"_1RAEx","priorityPrimary":"_1RAEx","disabled":"_2SpYE","priority-secondary":"_1z0wL","prioritySecondary":"_1z0wL"};